export default 'prod_awtech_demo'
